/* Ribbon chat box for rightgifting.com (Shopify theme asset).
 * Loaded by snippets/rg-ribbon.liquid, which also holds the settings (brain address, login state, page).
 * Talks to the Ribbon brain in n8n: sends { message, sessionId, page, cart, customer },
 * gets back { text_response, products, quick_replies, link, input }.
 * Build of 15 Oct 2026: help offers when a shopper looks stuck, also inside the design tool (no AI cost until tapped),
 * chat events for the team's Chats page (events_url), the chat's id on the cart (cart attribute _ribbon_chat) so orders
 * from the chat can be counted, a WhatsApp button to reach the team, and links to the shop's photo check page
 * (photo_check_url; Ryan, 15 Oct: photos are checked there, not sent in the chat).
 * The old chat box (rg-chatbot.js / rg-chatbot.css) is not touched by this file.
 */
(function () {
  'use strict';
  if (window.__rgRibbon) return;
  window.__rgRibbon = true;

  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('rg-ribbon-config').textContent); } catch (e) { return; }
  if (!CFG.endpoint) return;

  // ===== Words the shopper sees (safe to change) =====
  var TXT = {
    greeting: "Hi, I'm Ribbon, RightGifting's AI shop helper. Tell me who it's for or what you're looking for, and I'll show you options.",
    starts: ['Find a gift', 'Shop for myself', 'Delivery time', 'Order help'],
    startOnProduct: 'Sizes and prices',
    hello: 'Finding a gift? I can help.',
    helloSaved: 'Your chat is saved. Tap to carry on.',
    placeholder: 'Ask about gifts, sizes or delivery',
    thinking: ['Finding options…', 'Still looking, nearly there…'],
    error: "Sorry, I couldn't reach the shop just now. Please try again, or WhatsApp the team on +91 91106 36079.",
    retry: 'Try again',
    personalise: 'Personalise',
    personaliseSub: 'Add your photo or name',
    add: 'Add to cart',
    adding: 'Adding…',
    inCart: 'In cart',
    viewCart: 'View cart',
    pickTitle: 'Choose an option',
    pickBudget: 'Choose one in your budget',
    soldOut: 'Sold out',
    addFailed: "Couldn't add it. Please try again.",
    cleared: 'Chat cleared.',
    undo: 'Undo',
    note: 'Ribbon is an AI helper.',
    noteLink: 'WhatsApp the team',
    nudgeClose: 'Hide this offer',
  };
  // Help offers when a shopper looks stuck (build item 10). Ribbon's own words: no AI cost until the shopper taps.
  var NUDGE = {
    dwell: { say: 'Taking a while to decide? I can compare sizes, prices and delivery for this one.', chips: ['Sizes and prices', 'Delivery time'] },
    options: { say: 'Comparing options? Tell me who it is for and I will suggest the right one.', chips: ['Which size is best?', 'Price of each size'] },
    taps: { say: 'Is something not working? Tell me what happened, or WhatsApp the team on +91 91106 36079.', chips: ['Something is not working', 'Talk to the team'] },
    leave_cart: { say: 'Before you go: any question about delivery or personalising your gift?', chips: ['Delivery time', 'How do I personalise?'] },
    tool_idle: { say: 'Need a hand with the design? I can walk you through it.', chips: ['How do I add my photo?', 'Can I add text?'] },
    tool_upload: { say: 'Photo not going in? Check its quality first, or WhatsApp it to the team as a document and they will place it for you.', chips: ['Check photo quality', 'Talk to the team'] },
    tool_undo: { say: 'Tricky to get it just right? Tell me what you want, or the team can set it for you on WhatsApp.', chips: ['How do I add text?', 'Talk to the team'] },
    tool_error: { say: 'The design tool showed an error. WhatsApp your photo to the team as a document and they will make the design for you.', chips: ['Talk to the team', 'Check photo quality'] },
    tool_leave: { say: 'Did the design tool not work for you? The team can set your photo for you on WhatsApp.', chips: ['Talk to the team', 'Check photo quality'] },
  };
  // These tap buttons open a page straight away (no message to Ribbon, no AI cost).
  var TEAM_CHIP = /^(talk|chat|speak) (to|with) (the )?(team|a person|someone|us)$/i;
  var PHOTO_CHIP = /^(check (my |your |the )?photo( quality)?|check photo quality)$/i;
  var PHOTO_CHECK = /^https:\/\/[^\s"<>]+$/.test(String(CFG.photo_check_url || '')) ? String(CFG.photo_check_url) : ROOT_PHOTO_CHECK();
  var WHATSAPP = 'https://wa.me/919110636079';
  function ROOT_PHOTO_CHECK() { return 'https://check.rightgifting.com/'; } // Ryan's print check page (16 Oct)
  // ===================================================

  var ROOT = String(CFG.root || '/').replace(/\/?$/, '/'); // "/" or a language prefix such as "/hi/"
  var KEY = 'rg_ribbon_v1';
  var IDLE_MS = 24 * 3600 * 1000; // a chat left alone for a day starts fresh
  var MAX_MSGS = 60; // the brain answers 30 back-and-forths per chat
  var REPLY_TIMEOUT_MS = 60000;
  var MOBILE_Q = window.matchMedia('(max-width: 600px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  // ---------- Storage (per browser; a convenience, so every read and write is guarded) ----------
  function sget(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
  function sset(store, k, v) { try { window[store].setItem(k, v); } catch (e) { /* private mode or full */ } }
  function sdel(store, k) { try { window[store].removeItem(k); } catch (e) { /* ignore */ } }

  function newSid() {
    var a = new Uint8Array(9);
    (window.crypto || window.msCrypto).getRandomValues(a);
    var r = Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
    // Chats from a theme preview are tests: their ids start with "test-" so reports leave them out.
    var test = window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main';
    return (test ? 'test-rb-' : 'rb-') + Date.now().toString(36) + '-' + r;
  }

  var state = (function () {
    var s = null;
    try { s = JSON.parse(sget('localStorage', KEY) || 'null'); } catch (e) { s = null; }
    if (!s || typeof s !== 'object' || !Array.isArray(s.msgs) || !s.sid || Date.now() - (s.t || 0) > IDLE_MS) {
      return { sid: newSid(), t: Date.now(), msgs: [] };
    }
    return s;
  })();
  function save() {
    state.t = Date.now();
    state.msgs = state.msgs.slice(-MAX_MSGS);
    sset('localStorage', KEY, JSON.stringify(state));
  }

  // ---------- Small helpers ----------
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  var NBSP = String.fromCharCode(160); // no-break space (written this way so the uploaded file stays byte-identical)
  function rupees(n) { return '₹' + Math.round(Number(n)).toLocaleString('en-IN'); }
  function icon(name) {
    var P = {
      close: '<path d="M18 6 6 18M6 6l12 12"/>',
      send: '<path d="M12 19V5M5 12l7-7 7 7"/>',
      check: '<path d="M20 6 9 17l-5-5"/>',
      fresh: '<path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/>',
      bag: '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18M16 10a4 4 0 0 1-8 0"/>',
      left: '<path d="M15 6l-6 6 6 6"/>',
      right: '<path d="M9 6l6 6-6 6"/>',
      arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
      pin: '<path d="M12 21s-6.5-5.4-6.5-11a6.5 6.5 0 0 1 13 0c0 5.6-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.3"/>',
      chat: '<path d="M20 11.6a8 8 0 0 1-11.7 7.1L4 20l1.3-4A8 8 0 1 1 20 11.6z"/><path d="M9 10.5h6M9 13.5h4"/>',
      photo: '<rect x="3" y="4.5" width="18" height="15" rx="3"/><circle cx="9" cy="10" r="1.8"/><path d="m20.5 15.5-4.8-4.8L6 19.5"/>',
      truck: '<path d="M2.5 6.5h11v9.5h-11zM13.5 9.5h4.2l3.3 3.4v3.1h-7.5"/><circle cx="6.5" cy="17.5" r="1.7"/><circle cx="17" cy="17.5" r="1.7"/>',
    };
    return '<svg class="ic ic-' + name + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + P[name] + '</svg>';
  }
  // The logo: a chat bubble cut from marigold-print cloth (the print and its slow roll live in the CSS).
  var BUBBLE = '<span class="bub" aria-hidden="true"><span class="bub-cloth"><span class="bub-print"></span></span>' +
    '<svg class="bub-dots" viewBox="0 0 48 48" focusable="false"><circle cx="15.5" cy="19.5" r="3.1"/>' +
    '<circle cx="24" cy="19.5" r="3.1"/><circle cx="32.5" cy="19.5" r="3.1"/></svg></span>';
  var STAR = '<svg class="star" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2.8l2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.1l-5.7 3.2 1.2-6.4-4.7-4.4 6.4-.8z"/></svg>';
  function timeout(ms) {
    if (window.AbortController) { var c = new AbortController(); setTimeout(function () { c.abort(); }, ms); return c.signal; }
    return undefined;
  }

  // Links the brain may return: shop pages and Shopify images only.
  function shopPath(u) {
    try {
      var x = new URL(String(u), location.origin);
      if (x.host !== location.host && !/(^|\.)rightgifting\.com$/.test(x.hostname)) return null;
      if (!/^\/products\/[a-z0-9][a-z0-9-]*\/?$/i.test(x.pathname)) return null;
      return x.pathname + x.search;
    } catch (e) { return null; }
  }
  function handleOf(path) { var m = /^\/products\/([a-z0-9][a-z0-9-]*)/i.exec(path || ''); return m ? m[1].toLowerCase() : ''; }
  function imageUrl(u) {
    try {
      var x = new URL(String(u), location.origin);
      if (x.protocol !== 'https:' || !/(^|\.)(cdn\.shopify\.com|rightgifting\.com)$/.test(x.hostname)) return '';
      if (!x.searchParams.has('width')) x.searchParams.set('width', '480');
      return x.href;
    } catch (e) { return ''; }
  }
  function cleanProducts(list) {
    if (!Array.isArray(list)) return [];
    var out = [];
    list.slice(0, 8).forEach(function (p) {
      if (!p || typeof p !== 'object') return;
      var path = shopPath(p.productUrl);
      if (!path) return;
      out.push({
        name: String(p.name || '').replace(/\s+/g, ' ').trim().slice(0, 160),
        url: path,
        handle: handleOf(path),
        img: imageUrl(p.imageUrl),
        price: String(p.price || '').slice(0, 30),
        // Fix round 3 (Ryan, 16 Oct): the customer's budget; only the sizes inside it are offered.
        budget: Number(p.budget) > 0 && Number(p.budget) < 10000000 ? Number(p.budget) : 0,
      });
    });
    return out;
  }
  function cleanReplies(list) {
    if (!Array.isArray(list)) return [];
    return list.map(function (r) { return String(r || '').replace(/\s+/g, ' ').trim().slice(0, 40); })
      .filter(Boolean).slice(0, 4);
  }
  function shortName(n) { return String(n || '').split(' | ')[0]; }
  // The page link the brain may add under an answer: shop pages (same tab) or the shop on Google Maps (new tab).
  function cleanLink(l) {
    if (!l || typeof l !== 'object') return null;
    var label = String(l.label || '').replace(/\s+/g, ' ').trim().slice(0, 40);
    if (!label) return null;
    try {
      var x = new URL(String(l.url), location.origin);
      if (x.protocol !== 'https:') return null;
      if (x.hostname === 'maps.app.goo.gl' || (/(^|\.)google\.com$/.test(x.hostname) && /^\/maps/.test(x.pathname))) {
        return { label: label, href: x.href, ext: true };
      }
      // The courier's tracking page for the shopper's own order (from Shopify, through Ribbon's order tool).
      if (l.kind === 'tracking' && !x.username && !x.password) return { label: label, href: x.href, ext: true, kind: 'tracking' };
      // The team on WhatsApp (our number only), with a first message that names this chat.
      if (x.hostname === 'wa.me' && x.pathname === '/919110636079') return { label: label, href: teamLink(), ext: true, kind: 'whatsapp' };
      // The shop's photo check page opens in a new tab, so the shopper keeps their place.
      if (l.kind === 'photo-check') return { label: label, href: PHOTO_CHECK, ext: true, kind: 'photo-check' };
      if ((x.host === location.host || /(^|\.)rightgifting\.com$/.test(x.hostname)) && /^\/[\w\-\/]*$/.test(x.pathname)) {
        var path = /^\/pages\//.test(x.pathname) ? ROOT + x.pathname.slice(1) : x.pathname; // keeps a language prefix
        return { label: label, href: path, ext: false };
      }
    } catch (e) { /* not a link */ }
    return null;
  }
  function teamLink() {
    return WHATSAPP + '?text=' + encodeURIComponent('Hi RightGifting, I was chatting with Ribbon on your website (chat ' + state.sid + ').');
  }
  function openTeam(from) { track('link_click', { label: 'WhatsApp', from: from }); window.open(teamLink(), '_blank', 'noopener'); }
  function openPhotoCheck(from) { track('link_click', { label: 'Photo check', from: from }); window.open(PHOTO_CHECK, '_blank', 'noopener'); }
  // What the typing box says when Ribbon asked the shopper to type something (a pincode, a budget).
  function cleanInput(i) {
    if (!i || typeof i !== 'object' || !i.hint) return null;
    return { hint: String(i.hint).replace(/\s+/g, ' ').trim().slice(0, 60), keypad: i.keypad === 'numeric' ? 'numeric' : 'text' };
  }

  // Bot text: plain text, with the shop's phone, email and pages turned into links.
  var LINKS = /(\+91[\s-]?91106[\s-]?36079|91106[\s-]?36079|info@rightgifting\.com|https:\/\/maps\.app\.goo\.gl\/[\w-]+|(?:https?:\/\/)?(?:www\.)?rightgifting\.com\/[\w\-\/?=&.%]*[\w\/])/gi;
  function richText(node, text) {
    var s = String(text || '').replace(/\*\*|__|`/g, '');
    var last = 0;
    s.replace(LINKS, function (m, _g, at) {
      if (at > last) node.appendChild(document.createTextNode(s.slice(last, at)));
      var a = el('a', 'lnk', m);
      if (/@/.test(m)) a.href = 'mailto:' + m;
      else if (/36079/.test(m)) { a.href = teamLink(); a.target = '_blank'; a.rel = 'noopener'; }
      else if (/goo\.gl/i.test(m)) { a.href = m; a.target = '_blank'; a.rel = 'noopener'; }
      else a.href = /^https?:/i.test(m) ? m : 'https://' + m;
      node.appendChild(a);
      last = at + m.length;
      return m;
    });
    if (last < s.length) node.appendChild(document.createTextNode(s.slice(last)));
  }

  // ---------- What happens in the chat, for the team's Chats page (build items 10, 12) ----------
  // Small batches, sent with sendBeacon so a page change does not lose them. No names, phones or emails.
  var evQueue = [], evTimer = null;
  function pageKey() {
    var path = location.pathname.replace(ROOT === '/' ? /^$/ : new RegExp('^' + ROOT.replace(/\/$/, '')), '').toLowerCase();
    var m = /^\/(products|collections|pages|blogs)\/([a-z0-9][a-z0-9_-]*)/.exec(path);
    if (m) return m[1] + '/' + m[2].slice(0, 120);
    if (path === '/' || path === '') return 'home';
    if (/^\/cart/.test(path)) return 'cart';
    if (/^\/search/.test(path)) return 'search';
    return 'other';
  }
  function track(kind, detail) {
    if (!CFG.events_url) return;
    var d = {};
    Object.keys(detail || {}).forEach(function (k) {
      var v = detail[k];
      if (typeof v === 'string') v = v.replace(/\s+/g, ' ').trim().slice(0, 120);
      if (v !== '' && v !== null && v !== undefined) d[k] = v;
    });
    evQueue.push({ s: state.sid, k: kind, p: pageKey(), d: d });
    if (evQueue.length >= 10) flushEvents();
    else if (!evTimer) evTimer = setTimeout(flushEvents, 4000);
  }
  function flushEvents() {
    clearTimeout(evTimer); evTimer = null;
    while (evQueue.length) {
      var data = new URLSearchParams();
      data.set('d', JSON.stringify(evQueue.splice(0, 25)));
      var sent = false;
      try { sent = !!(navigator.sendBeacon && navigator.sendBeacon(CFG.events_url, data)); } catch (e) { sent = false; }
      if (!sent) { try { fetch(CFG.events_url, { method: 'POST', body: data, keepalive: true, mode: 'no-cors' }).catch(function () {}); } catch (e) { /* not important */ } }
    }
  }
  window.addEventListener('pagehide', flushEvents);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flushEvents(); });

  // The chat's id goes on the cart (a hidden cart attribute), so an order placed after chatting can be counted.
  function tagCart() {
    if (sget('sessionStorage', 'rg_ribbon_cart_tag') === state.sid) return;
    sset('sessionStorage', 'rg_ribbon_cart_tag', state.sid);
    fetch(ROOT + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _ribbon_chat: state.sid } }),
    }).then(function (r) { if (!r.ok) throw new Error('tag'); }).catch(function () { sdel('sessionStorage', 'rg_ribbon_cart_tag'); });
  }

  // ---------- Cart (theme's /cart.js) ----------
  var inCart = {}, cartCount = 0;
  function readCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, signal: timeout(4000), credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        inCart = {};
        cartCount = c.item_count || 0;
        var items = (c.items || []).slice(0, 20).map(function (it) {
          inCart[it.handle] = true;
          return { handle: it.handle, title: it.product_title || it.title, quantity: it.quantity, price: (it.final_price || it.price || 0) / 100 };
        });
        return { items: items, item_count: c.item_count || 0, total: (c.total_price || 0) / 100 };
      })
      .catch(function () { return null; });
  }

  // Product facts for the cards: variants, prices and star rating. Uses the theme template
  // "product.ribbon" (/products/<handle>?view=ribbon); falls back to /products/<handle>.js (no rating).
  var facts = {};
  function getFacts(handle) {
    if (facts[handle]) return facts[handle];
    var base = ROOT + 'products/' + encodeURIComponent(handle);
    // No "Accept: application/json" header here: with it, Shopify answers with its own product JSON, not the template.
    facts[handle] = fetch(base + '?view=ribbon', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('view'); return r.json(); })
      .then(function (j) { if (!j || !Array.isArray(j.variants)) throw new Error('shape'); return j; })
      .catch(function () {
        return fetch(base + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('js'); return r.json(); });
      })
      .then(function (p) {
        var variants = (p.variants || []).slice(0, 40).map(function (v) {
          return { id: v.id, title: String(v.title || ''), price: Number(v.price) / 100, available: v.available !== false };
        });
        var prices = variants.map(function (v) { return v.price; }).filter(function (n) { return n > 0; });
        var opts = (p.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
        return {
          variants: variants,
          min: prices.length ? Math.min.apply(null, prices) : null,
          max: prices.length ? Math.max.apply(null, prices) : null,
          sizeOnly: opts.length === 1 && /size/i.test(opts[0]),
          rating: Number(p.rating) || 0,
          ratingCount: Number(p.rating_count) || 0,
          available: p.available !== false,
        };
      })
      .catch(function () { delete facts[handle]; return null; });
    return facts[handle];
  }

  function addToCart(variantId) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: variantId, quantity: 1, properties: { _source: 'Ribbon chat' } }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = location.pathname;
      } catch (e) { /* the theme changed: the cart page still shows the item */ }
    }
    return fetch(CFG.cart_add_url || '/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok && !j.status, data: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'add');
        // Let the theme refresh its cart drawer and cart count, as its own Add to cart does.
        try { if (drawer && res.data.sections && typeof drawer.renderContents === 'function') drawer.renderContents(res.data); } catch (e) { /* ignore */ }
        try {
          var T = window.NextSkyTheme;
          if (T && T.publish && T.PUB_SUB_EVENTS) T.publish(T.PUB_SUB_EVENTS.cartUpdate, { source: 'ribbon', productVariantId: variantId, cartData: res.data });
        } catch (e) { /* ignore */ }
        return res.data;
      });
  }
  function openCart() {
    close();
    var icon = document.getElementById('cart-icon-bubble') || document.getElementById('cart-icon-bubble-mobile');
    if (document.querySelector('cart-drawer') && icon) icon.click();
    else location.href = CFG.cart_url || '/cart';
  }

  // ---------- Build the box ----------
  var host = el('div');
  host.id = 'rg-ribbon';
  host.style.visibility = 'hidden';
  var root = host.attachShadow ? host.attachShadow({ mode: 'open' }) : host;
  root.innerHTML =
    '<link rel="stylesheet" href="' + String(CFG.css || '').replace(/"/g, '') + '">' +
    '<div class="rb">' +
    '<button class="launch" type="button" aria-expanded="false" aria-controls="rb-panel" aria-label="Chat with Ribbon, the RightGifting shop helper">' +
    '<span class="launch-ic">' + BUBBLE + '</span><span class="launch-x">' + icon('close') + '</span><span class="count" hidden>1</span></button>' +
    '<div class="hello" hidden><button class="hello-go" type="button"></button><button class="hello-x" type="button" aria-label="Hide this message">' + icon('close') + '</button></div>' +
    '<div class="nudge" role="status" hidden><div class="nudge-top"><button class="nudge-go" type="button"></button>' +
    '<button class="nudge-x" type="button" aria-label="' + TXT.nudgeClose + '">' + icon('close') + '</button></div><div class="nudge-chips"></div></div>' +
    '<section class="panel" id="rb-panel" role="dialog" aria-labelledby="rb-name" hidden>' +
    '<header class="head"><span class="mark">' + BUBBLE + '</span><div class="who"><h2 class="name" id="rb-name">Ribbon</h2>' +
    '<p class="sub">AI shop helper · RightGifting</p></div>' +
    '<button class="hbtn fresh" type="button" aria-label="Start a new chat" title="Start a new chat">' + icon('fresh') + '</button>' +
    '<button class="hbtn x" type="button" aria-label="Close chat" title="Close">' + icon('close') + '</button></header>' +
    '<div class="log" role="log" aria-live="polite" aria-relevant="additions" tabindex="-1"></div>' +
    '<form class="foot" novalidate><div class="row">' +
    '<label class="sr" for="rb-in">Message Ribbon</label>' +
    '<input id="rb-in" class="in" type="text" maxlength="500" autocomplete="off" enterkeyhint="send">' +
    '<button class="send" type="submit" aria-label="Send">' + icon('send') + '</button></div>' +
    '<p class="note"></p></form>' +
    '</section></div>';

  var $ = function (s) { return root.querySelector(s); };
  var box = $('.rb'), launch = $('.launch'), count = $('.count'), hello = $('.hello'), helloGo = $('.hello-go'),
    panel = $('#rb-panel'), log = $('.log'), form = $('.foot'), input = $('.in'), sendBtn = $('.send'),
    nudgeEl = $('.nudge');
  input.placeholder = TXT.placeholder;
  var note = $('.note');
  note.appendChild(document.createTextNode(TXT.note + ' '));
  var wa = el('a', 'lnk', TXT.noteLink);
  wa.href = WHATSAPP; wa.target = '_blank'; wa.rel = 'noopener';
  note.appendChild(wa);

  // Page-level rules that cannot live inside the box: the scroll lock while the phone chat is open.
  var pageStyle = el('style');
  pageStyle.textContent = 'html.rg-ribbon-lock,html.rg-ribbon-lock body{overflow:hidden!important;}';
  document.head.appendChild(pageStyle);

  var fontsLoaded = false;
  function loadFonts() {
    if (fontsLoaded || !CFG.fonts) return;
    fontsLoaded = true;
    var l = el('link'); l.rel = 'stylesheet'; l.href = CFG.fonts; document.head.appendChild(l);
  }

  // ---------- Messages ----------
  var repliesEl = null; // tap buttons under the latest answer only

  // The shopper leaves the page from the chat (a card or a shop page): the next page says the chat is saved.
  function leaving() { sset('sessionStorage', 'rg_ribbon_from_card', '1'); }

  // fresh: a message that just arrived (it moves in); a chat restored from storage appears still.
  function addRow(m, fresh) {
    if (m.hide || m.up) return null; // chats saved before 15 Oct evening may hold old upload notes
    if (m.r === 'me') {
      var me = el('div', 'msg me' + (fresh ? ' new' : ''));
      me.appendChild(el('p', null, m.text));
      log.appendChild(me);
      return me;
    }
    var wrap = el('div', 'turn' + (fresh ? ' new' : ''));
    var bot = el('div', 'msg bot' + (m.err ? ' err' : ''));
    var p = el('p');
    richText(p, m.text);
    bot.appendChild(p);
    wrap.appendChild(bot);
    if (m.link) {
      var kind = m.link.kind || '';
      var go = el('a', 'golink' + (kind === 'tracking' ? ' track' : kind === 'whatsapp' ? ' wa' : ''));
      go.href = m.link.href;
      if (m.link.ext) {
        go.target = '_blank'; go.rel = 'noopener';
        go.innerHTML = icon(kind === 'tracking' ? 'truck' : kind === 'whatsapp' ? 'chat' : kind === 'photo-check' ? 'photo' : 'pin');
      } else go.addEventListener('click', leaving);
      go.addEventListener('click', function () { track('link_click', { label: m.link.label }); });
      go.appendChild(document.createTextNode(m.link.label));
      if (!m.link.ext) go.insertAdjacentHTML('beforeend', icon('arrow'));
      wrap.appendChild(go);
    }
    if (m.products && m.products.length) wrap.appendChild(swatches(m.products));
    log.appendChild(wrap);
    return wrap;
  }

  function setReplies(list, retry, fresh) {
    if (repliesEl) { repliesEl.remove(); repliesEl = null; }
    if (!list || !list.length) return;
    var r = repliesEl = el('div', 'replies' + (fresh ? ' new' : ''));
    r.setAttribute('role', 'group');
    r.setAttribute('aria-label', 'Quick replies');
    list.forEach(function (label, i) {
      var b = el('button', 'chip', label);
      b.type = 'button';
      b.style.setProperty('--i', i);
      b.addEventListener('click', function () {
        if (TEAM_CHIP.test(label)) { openTeam('button'); return; }
        if (PHOTO_CHIP.test(label)) { openPhotoCheck('button'); return; }
        send(retry && label === TXT.retry ? retry : label);
      });
      r.appendChild(b);
    });
    log.appendChild(r);
    // One row: when it is wider than the chat, its right end fades to show there is more.
    var edge = function () { r.classList.toggle('more', r.scrollLeft + r.clientWidth < r.scrollWidth - 4); };
    r.addEventListener('scroll', edge, { passive: true });
    requestAnimationFrame(edge);
  }
  function setHint(h) {
    input.placeholder = h ? h.hint : TXT.placeholder;
    input.setAttribute('inputmode', h && h.keypad === 'numeric' ? 'numeric' : 'text');
  }

  function swatches(list) {
    var strip = el('div', 'strip');
    var ul = el('ul', 'swatches');
    ul.setAttribute('aria-label', list.length === 1 ? '1 product' : list.length + ' products');
    list.forEach(function (p, i) { var li = swatch(p); li.style.setProperty('--i', i); ul.appendChild(li); });
    strip.appendChild(ul);
    // Arrows for mouse users (a mouse wheel scrolls the chat, not the strip). Shown only with a mouse.
    var prev = el('button', 'nav prev'), next = el('button', 'nav next');
    prev.type = next.type = 'button';
    prev.setAttribute('aria-label', 'Previous products');
    next.setAttribute('aria-label', 'More products');
    prev.innerHTML = icon('left'); next.innerHTML = icon('right');
    prev.addEventListener('click', function () { ul.scrollBy({ left: -220, behavior: REDUCED.matches ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { ul.scrollBy({ left: 220, behavior: REDUCED.matches ? 'auto' : 'smooth' }); });
    strip.appendChild(prev); strip.appendChild(next);
    var queued = false;
    function ends() {
      queued = false;
      prev.hidden = ul.scrollLeft < 8;
      next.hidden = ul.scrollLeft + ul.clientWidth >= ul.scrollWidth - 8;
    }
    ul.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(ends); } }, { passive: true });
    requestAnimationFrame(ends);
    return strip;
  }

  function swatch(p) {
    var li = el('li', 'sw');
    var cloth = el('a', 'cloth');
    cloth.href = p.url;
    cloth.tabIndex = -1;
    cloth.setAttribute('aria-hidden', 'true');
    if (p.img) {
      var img = el('img');
      img.src = p.img; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async'; img.width = 240; img.height = 240;
      cloth.appendChild(img);
    }
    var badge = el('span', 'badge');
    badge.innerHTML = icon('check');
    badge.appendChild(document.createTextNode(TXT.inCart));
    cloth.appendChild(badge);
    li.appendChild(cloth);

    var body = el('div', 'body');
    var title = el('a', 'title', shortName(p.name));
    title.href = p.url;
    body.appendChild(title);
    var rate = el('p', 'rate');
    rate.hidden = true;
    body.appendChild(rate);

    var label = el('div', 'label');
    var priceM = /^(From\s*)?₹\s*([\d,]+)/i.exec(p.price || '');
    var from = el('span', 'from', priceM && priceM[1] ? 'From' : 'Price');
    var amount = el('b', 'amt', priceM ? '₹' + priceM[2] : '');
    var extra = el('span', 'extra');
    label.appendChild(from); label.appendChild(amount); label.appendChild(extra);
    if (!priceM) label.hidden = true;
    body.appendChild(label);

    var go = el('a', 'btn fill');
    go.href = p.url;
    go.appendChild(el('b', null, TXT.personalise));
    go.appendChild(el('small', null, TXT.personaliseSub));
    var add = el('button', 'btn line');
    add.type = 'button';
    add.innerHTML = icon('bag');
    var addText = el('span', null, TXT.add);
    add.appendChild(addText);
    var view = el('button', 'btn line done');
    view.type = 'button';
    view.innerHTML = icon('check');
    view.appendChild(el('span', null, TXT.inCart + ' · ' + TXT.viewCart));
    view.hidden = true;
    var pick = el('div', 'pick');
    pick.hidden = true;
    var msg = el('p', 'cardmsg');
    msg.setAttribute('role', 'status');
    body.appendChild(go); body.appendChild(add); body.appendChild(view); body.appendChild(pick); body.appendChild(msg);
    li.appendChild(body);

    function markInCart() {
      li.classList.add('is-incart');
      add.hidden = true; pick.hidden = true; view.hidden = false; msg.textContent = '';
    }
    if (inCart[p.handle]) markInCart();

    [cloth, title, go].forEach(function (a) { a.addEventListener('click', leaving); });
    [cloth, title].forEach(function (a) { a.addEventListener('click', function () { track('card_click', { title: shortName(p.name) }); }); });
    go.addEventListener('click', function () { tagCart(); track('personalise_click', { title: shortName(p.name) }); });
    view.addEventListener('click', function () { track('view_cart'); openCart(); });

    function doAdd(variantId) {
      add.disabled = true; addText.textContent = TXT.adding; msg.textContent = '';
      pick.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
      addToCart(variantId).then(function () {
        inCart[p.handle] = true;
        markInCart();
        tagCart();
        track('add_to_cart', { title: shortName(p.name) });
      }).catch(function (e) {
        msg.textContent = /sold out|not available|inventory/i.test(String(e && e.message)) ? TXT.soldOut + '.' : TXT.addFailed;
        pick.querySelectorAll('button').forEach(function (b) { b.disabled = b.dataset.soldout === '1'; });
      }).then(function () { add.disabled = false; addText.textContent = TXT.add; });
    }

    add.addEventListener('click', function () {
      if (!pick.hidden) { pick.hidden = true; add.setAttribute('aria-expanded', 'false'); return; }
      add.disabled = true;
      getFacts(p.handle).then(function (f) {
        add.disabled = false;
        if (!f || !f.variants.length) { location.href = p.url; return; }
        var vs = inBudget(f);
        var live = vs.filter(function (v) { return v.available; });
        if (vs.length === 1) { if (live.length) doAdd(live[0].id); else msg.textContent = TXT.soldOut + '.'; return; }
        pick.innerHTML = '';
        pick.appendChild(el('p', 'pick-t', vs.length < f.variants.length ? TXT.pickBudget : TXT.pickTitle));
        var same = f.min === f.max;
        vs.slice(0, 12).forEach(function (v) {
          var b = el('button', 'opt');
          b.type = 'button';
          b.appendChild(el('span', 'opt-t', v.title.replace(/\(([^)]*)\)/g, function (m) { return m.replace(/ /g, NBSP); }).replace(/ \(/g, NBSP + '(')));
          if (!same && v.price) b.appendChild(el('span', 'opt-p', rupees(v.price)));
          if (!v.available) { b.disabled = true; b.dataset.soldout = '1'; b.title = TXT.soldOut; b.classList.add('out'); }
          b.addEventListener('click', function () { doAdd(v.id); });
          pick.appendChild(b);
        });
        if (vs.length > 12) {
          var more = el('a', 'lnk opt-more', 'More options on the product page');
          more.href = p.url;
          more.addEventListener('click', leaving);
          pick.appendChild(more);
        }
        pick.hidden = false;
        add.setAttribute('aria-expanded', 'true');
        revealInLog(pick);
        var first = pick.querySelector('.opt:not([disabled])');
        if (first) first.focus({ preventScroll: true });
      });
    });

    // The sizes this card offers: all of them, or only those inside the customer's budget.
    function inBudget(f) {
      if (!p.budget) return f.variants;
      var vs = f.variants.filter(function (v) { return v.price > 0 && v.price <= p.budget; });
      return vs.length ? vs : f.variants;
    }
    // Fill in the real price range, options and star rating.
    getFacts(p.handle).then(function (f) {
      if (!f) return;
      var vs = inBudget(f);
      var ps = vs.map(function (v) { return v.price; }).filter(function (n) { return n > 0; });
      var lo = ps.length ? Math.min.apply(null, ps) : f.min, hi = ps.length ? Math.max.apply(null, ps) : f.max;
      if (lo) {
        from.textContent = hi > lo ? 'From' : 'Price';
        amount.textContent = rupees(lo);
        label.hidden = false;
      }
      // Short, so it fits next to the price on a phone; the size list says "Choose one in your budget".
      if (vs.length < f.variants.length) extra.textContent = vs.length + (vs.length === 1 ? (f.sizeOnly ? ' size fits' : ' option fits') : (f.sizeOnly ? ' sizes fit' : ' options fit'));
      else if (f.variants.length > 1) extra.textContent = f.variants.length + (f.sizeOnly ? ' sizes' : ' options');
      if (f.ratingCount > 0 && f.rating > 0) {
        rate.innerHTML = STAR;
        rate.appendChild(el('b', null, f.rating.toFixed(1)));
        rate.appendChild(document.createTextNode(' (' + f.ratingCount + (f.ratingCount === 1 ? ' review)' : ' reviews)')));
        rate.setAttribute('aria-label', 'Rated ' + f.rating.toFixed(1) + ' out of 5 from ' + f.ratingCount + ' reviews');
        rate.hidden = false;
      }
      if (!f.available && !li.classList.contains('is-incart')) { add.disabled = true; addText.textContent = TXT.soldOut; }
    });
    return li;
  }

  var typingEl = null, typingTimers = [];
  function showTyping() {
    typingEl = el('div', 'msg bot typing');
    // A print head runs along its rail and prints a line of ink dots (the shop prints, Ryan 15 Oct).
    typingEl.innerHTML = '<span class="printer" aria-hidden="true"><span class="rail"></span><span class="ink"></span><span class="carriage"></span></span>';
    var t = el('span', 'typing-t');
    typingEl.appendChild(t);
    var sr = el('span', 'sr', 'Ribbon is replying');
    typingEl.appendChild(sr);
    log.appendChild(typingEl);
    scrollToEnd();
    typingTimers = [
      setTimeout(function () { t.textContent = TXT.thinking[0]; }, 3500),
      setTimeout(function () { t.textContent = TXT.thinking[1]; }, 14000),
    ];
  }
  function hideTyping() {
    typingTimers.forEach(clearTimeout);
    if (typingEl) { typingEl.remove(); typingEl = null; }
  }

  function scrollToEnd() { log.scrollTop = log.scrollHeight; }
  // Bring something inside the chat fully into view (for example the size choices under a card).
  function revealInLog(node) {
    var lr = log.getBoundingClientRect(), nr = node.getBoundingClientRect();
    var by = 0;
    if (nr.bottom > lr.bottom - 12) by = nr.bottom - lr.bottom + 12;
    if (nr.top - by < lr.top + 12) by = nr.top - lr.top - 12;
    if (by) log.scrollTo({ top: log.scrollTop + by, behavior: REDUCED.matches ? 'auto' : 'smooth' });
  }
  function scrollToRow(row) {
    // Show the start of the answer, so the text is read before the products. When the chat is too short
    // for the text and a whole card (small laptop screens), show the cards with their buttons instead.
    var lr = log.getBoundingClientRect();
    var target = row;
    var strip = row.querySelector('.strip');
    var btn = row.querySelector('.btn.fill');
    var need = btn ? btn.getBoundingClientRect().bottom - row.getBoundingClientRect().top + 28 : 0;
    if (strip && need > log.clientHeight) target = strip;
    var top = log.scrollTop + target.getBoundingClientRect().top - lr.top - 20; // the message above fades out under the header
    log.scrollTo({ top: Math.max(0, top), behavior: REDUCED.matches ? 'auto' : 'smooth' });
  }

  function renderAll() {
    log.innerHTML = '';
    repliesEl = null;
    syncFresh();
    if (!state.msgs.length) {
      addRow({ r: 'bot', text: TXT.greeting });
      var starts = TXT.starts.slice();
      if (CFG.page && CFG.page.handle) starts.unshift(TXT.startOnProduct);
      setReplies(starts);
      setHint(null);
      return;
    }
    state.msgs.forEach(function (m) { addRow(m); });
    var last = state.msgs[state.msgs.length - 1];
    if (last.r === 'bot') setReplies(last.replies, last.retry);
    setHint(last.r === 'bot' ? last.input : null);
    scrollToEnd();
  }

  // ---------- Sending ----------
  var busy = false;
  function send(text) {
    text = String(text || '').replace(/\s+/g, ' ').trim().slice(0, 500);
    if (!text || busy) return;
    busy = true;
    sendBtn.disabled = true;
    sendBtn.classList.remove('go'); void sendBtn.offsetWidth; sendBtn.classList.add('go'); // the arrow nudges up
    setHint(null);
    // The greeting stays on screen as the first message (the brain never sees it).
    if (!state.msgs.length) state.msgs.push({ r: 'bot', text: TXT.greeting, local: true });
    setReplies(null);
    var mine = { r: 'me', text: text };
    state.msgs.push(mine);
    addRow(mine, true);
    save();
    syncFresh();
    showTyping();
    readCart().then(function (cart) {
      var body = {
        message: text,
        sessionId: state.sid,
        page: CFG.page && CFG.page.handle ? CFG.page : null,
        cart: cart,
        customer: CFG.customer || null,
      };
      return fetch(CFG.endpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: timeout(REPLY_TIMEOUT_MS),
      }).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); });
    }).then(function (data) {
      var reply = String((data && (data.text_response || data.output)) || '').trim();
      if (!reply) throw new Error('empty');
      var m = { r: 'bot', text: reply.slice(0, 2000), products: cleanProducts(data.products), replies: cleanReplies(data.quick_replies) };
      var link = cleanLink(data.link), hint = cleanInput(data.input);
      if (link) m.link = link;
      if (hint) m.input = hint;
      tagCart();
      return m;
    }).catch(function (e) {
      track('error', { why: String((e && e.name === 'AbortError') ? 'timeout' : (e && e.message) || 'error').slice(0, 60) });
      return { r: 'bot', err: true, text: TXT.error, replies: [TXT.retry], retry: text };
    }).then(function (m) {
      hideTyping();
      state.msgs.push(m);
      save();
      var row = addRow(m, true);
      setReplies(m.replies, m.retry, true);
      setHint(m.input);
      if (panel.hidden) syncCount();
      if (m.products && m.products.length) scrollToRow(row); else scrollToEnd();
      busy = false;
      sendBtn.disabled = false;
    });
  }

  // A message from Ribbon written in the chat box itself (help offers): no AI cost.
  function localBot(text, replies) {
    if (!state.msgs.length) state.msgs.push({ r: 'bot', text: TXT.greeting, local: true });
    var m = { r: 'bot', text: text, replies: replies || [], local: true };
    state.msgs.push(m);
    save();
    setReplies(null);
    addRow(m, true);
    setReplies(m.replies, null, true);
    syncFresh();
    scrollToEnd();
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = input.value;
    if (!v.trim() || busy) return;
    input.value = '';
    send(v);
  });

  // ---------- Open, close, hello ----------
  var lastFocus = null, closeTimer = null;
  var LAUNCH_LABEL = 'Chat with Ribbon, the RightGifting shop helper';
  function isMobile() { return MOBILE_Q.matches; }
  // The red "1" on the button: a chat is saved and waiting.
  function syncCount() {
    var waiting = state.msgs.length > 0 && panel.hidden;
    count.hidden = !waiting;
    launch.setAttribute('aria-label', panel.hidden ? LAUNCH_LABEL + (waiting ? '. Your chat is saved.' : '') : 'Close chat');
  }
  var lastClosedAt = 0;
  function open(from) {
    loadFonts();
    hideHello(true);
    hideNudge();
    if (panel.hidden || panel.classList.contains('is-closing')) track('chat_open', { from: typeof from === 'string' ? from : 'button' });
    clearTimeout(closeTimer);
    panel.classList.remove('is-closing');
    if (!log.childNodes.length) renderAll();
    panel.hidden = false;
    box.classList.add('is-open');
    launch.setAttribute('aria-expanded', 'true');
    syncCount();
    panel.setAttribute('aria-modal', isMobile() ? 'true' : 'false');
    if (isMobile()) document.documentElement.classList.add('rg-ribbon-lock');
    fitViewport();
    readCart().then(function () {
      root.querySelectorAll('.sw').forEach(function (li) {
        var a = li.querySelector('.title');
        var h = a && handleOf(a.getAttribute('href'));
        if (h && inCart[h] && !li.classList.contains('is-incart')) {
          li.classList.add('is-incart');
          li.querySelector('.btn.line:not(.done)').hidden = true;
          li.querySelector('.btn.done').hidden = false;
        }
      });
    });
    lastFocus = document.activeElement;
    if (isMobile()) setTimeout(function () { log.focus({ preventScroll: true }); }, 60);
    else setTimeout(function () { input.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    if (panel.hidden || panel.classList.contains('is-closing')) return;
    lastClosedAt = Date.now();
    track('chat_close', { msgs: state.msgs.length });
    box.classList.remove('is-open');
    launch.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('rg-ribbon-lock');
    var done = function () { panel.classList.remove('is-closing'); panel.hidden = true; syncCount(); };
    if (REDUCED.matches) done();
    else { panel.classList.add('is-closing'); closeTimer = setTimeout(done, 170); }
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    else launch.focus({ preventScroll: true });
  }
  launch.addEventListener('click', function () { panel.hidden || panel.classList.contains('is-closing') ? open('button') : close(); });
  $('.hbtn.x').addEventListener('click', close);
  var undoTimer = null;
  $('.hbtn.fresh').addEventListener('click', function () {
    if (busy) return;
    var before = state;
    state = { sid: newSid(), t: Date.now(), msgs: [] };
    save();
    renderAll();
    track('new_chat');
    var bar = el('div', 'undo');
    bar.setAttribute('role', 'status');
    bar.appendChild(el('span', null, TXT.cleared));
    var ub = el('button', 'lnk undo-b', TXT.undo);
    ub.type = 'button';
    ub.addEventListener('click', function () {
      clearTimeout(undoTimer);
      state = before;
      save();
      renderAll();
      input.focus({ preventScroll: true });
    });
    bar.appendChild(ub);
    log.insertBefore(bar, log.firstChild);
    clearTimeout(undoTimer);
    undoTimer = setTimeout(function () { if (bar.parentNode) bar.remove(); }, 8000);
    ub.focus({ preventScroll: true });
  });
  function syncFresh() { $('.hbtn.fresh').hidden = !state.msgs.length; }
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) { e.stopPropagation(); close(); return; }
    if (e.key === 'Tab' && !panel.hidden && isMobile()) {
      var f = Array.prototype.filter.call(panel.querySelectorAll('a[href],button:not([disabled]),input'), function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var a = root.activeElement;
      if (e.shiftKey && a === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && a === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  var helloTimer = null;
  function showHello(text) {
    loadFonts();
    helloGo.textContent = text;
    hello.hidden = false;
    requestAnimationFrame(function () { hello.classList.add('on'); });
    helloTimer = setTimeout(function () { hideHello(); }, 9000);
  }
  function hideHello(now) {
    clearTimeout(helloTimer);
    if (hello.hidden) return;
    hello.classList.remove('on');
    setTimeout(function () { hello.hidden = true; }, now || REDUCED.matches ? 0 : 250);
  }
  helloGo.addEventListener('click', function () { open('hello'); });
  $('.hello-x').addEventListener('click', function () { hideHello(true); });

  // ---------- Help offers when a shopper looks stuck (build item 10) ----------
  // At most one offer a page and two a visit; none after the shopper closes one, none while the chat is open,
  // and none for 2 minutes after the chat was closed. Only a tap costs AI credit (it sends a message to Ribbon).
  var nudgedPage = false, nudgeKind = '', nudgeTimer = null;
  function canNudge(kind) {
    if (nudgedPage || busy || !panel.hidden || box.classList.contains('is-away')) return false;
    if (sget('sessionStorage', 'rg_ribbon_nudge_off') === '1') return false;
    if (Number(sget('sessionStorage', 'rg_ribbon_nudges') || 0) >= 2) return false;
    if (Date.now() - lastClosedAt < 120000) return false;
    if (CFG.template === 'cart' && kind !== 'leave_cart') return false;
    if (/^tool_/.test(kind) === false && toolEl()) return false;
    return true;
  }
  function nudge(kind) {
    var n = NUDGE[kind];
    if (!n || !canNudge(kind)) return;
    nudgedPage = true; nudgeKind = kind;
    sset('sessionStorage', 'rg_ribbon_nudges', String(Number(sget('sessionStorage', 'rg_ribbon_nudges') || 0) + 1));
    loadFonts();
    hideHello(true);
    $('.nudge-go').textContent = n.say;
    var chips = $('.nudge-chips');
    chips.innerHTML = '';
    n.chips.forEach(function (label, i) {
      var b = el('button', 'chip', label);
      b.type = 'button';
      b.style.setProperty('--i', i);
      b.addEventListener('click', function () {
        track('nudge_click', { nudge: kind, chip: label });
        hideNudge();
        if (TEAM_CHIP.test(label)) { openTeam('offer'); return; }
        if (PHOTO_CHIP.test(label)) { openPhotoCheck('offer'); return; }
        open('nudge');
        send(label);
      });
      chips.appendChild(b);
    });
    nudgeEl.hidden = false;
    requestAnimationFrame(function () { nudgeEl.classList.add('on'); });
    clearTimeout(nudgeTimer);
    nudgeTimer = setTimeout(hideNudge, 25000);
    track('nudge_shown', { nudge: kind });
  }
  function hideNudge() {
    clearTimeout(nudgeTimer);
    if (nudgeEl.hidden) return;
    nudgeEl.classList.remove('on');
    setTimeout(function () { nudgeEl.hidden = true; }, REDUCED.matches ? 0 : 250);
  }
  $('.nudge-go').addEventListener('click', function () {
    var n = NUDGE[nudgeKind];
    track('nudge_click', { nudge: nudgeKind });
    hideNudge();
    open('nudge');
    if (n && !busy) localBot(n.say, n.chips);
  });
  $('.nudge-x').addEventListener('click', function () {
    track('nudge_close', { nudge: nudgeKind });
    sset('sessionStorage', 'rg_ribbon_nudge_off', '1');
    hideNudge();
  });

  // Signs on a product page: a long look without adding, many option changes, the same spot tapped again and again,
  // and (computer) the mouse heading out of the page with items in the cart.
  var onProduct = CFG.template === 'product' && !!(CFG.page && CFG.page.handle);
  var activeSecs = 0, lastActive = Date.now(), addedHere = false, optionTimes = [], taps = [], pageStart = Date.now();
  ['scroll', 'pointerdown', 'keydown', 'touchstart', 'mousemove'].forEach(function (t) {
    window.addEventListener(t, function () { lastActive = Date.now(); }, { passive: true, capture: true });
  });
  setInterval(function () {
    if (document.hidden || Date.now() - lastActive > 30000) return;
    activeSecs += 5;
    if (onProduct && !addedHere && activeSecs >= 75) nudge('dwell');
  }, 5000);
  function fromRibbon(e) { return e.composedPath && e.composedPath().indexOf(host) >= 0; }
  document.addEventListener('click', function (e) {
    if (fromRibbon(e)) return;
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('form[action*="/cart/add"] [type="submit"], button[name="add"], .product-form__submit, .sb-pd-popup_addtocartbutton')) addedHere = true;
    if (tool.open) {
      if (t.closest('.sb-pd-popup_addtocartbutton')) tool.added = true;
      var b = t.closest('button, [role="button"], a');
      var words = b ? ((b.getAttribute('aria-label') || '') + ' ' + (b.getAttribute('title') || '') + ' ' + (b.textContent || '')).slice(0, 80) : '';
      if (/\bundo\b/i.test(words)) { tool.undos.push(Date.now()); tool.undos = tool.undos.filter(function (x) { return Date.now() - x < 60000; }); if (tool.undos.length >= 5) nudge('tool_undo'); }
    }
    // The same spot tapped 5 times in 1.5 seconds (not number boxes, quantity buttons or sliders).
    if (t.closest('input, select, textarea, label, quantity-input, .quantity, [name="quantity"], [class*="slider"], [class*="swiper"], [class*="carousel"]')) return;
    var now = Date.now();
    taps.push({ t: now, x: e.clientX, y: e.clientY });
    taps = taps.filter(function (x) { return now - x.t < 1500; });
    if (taps.length >= 5 && taps.every(function (x) { return Math.abs(x.x - e.clientX) < 40 && Math.abs(x.y - e.clientY) < 40; })) { taps = []; nudge('taps'); }
  }, true);
  document.addEventListener('change', function (e) {
    if (fromRibbon(e)) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (tool.open && t.type === 'file' && t.closest('.sb-customize-product-popup')) {
      tool.files.push(Date.now()); tool.files = tool.files.filter(function (x) { return Date.now() - x < 120000; });
      if (tool.files.length >= 3) nudge('tool_upload');
      return;
    }
    if (onProduct && t.closest('form[action*="/cart/add"], variant-selects, variant-radios, .product-form__input, .product__info-container')) {
      var now = Date.now();
      optionTimes.push(now); optionTimes = optionTimes.filter(function (x) { return now - x < 60000; });
      if (optionTimes.length >= 6) nudge('options');
    }
  }, true);
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 4 || Date.now() - pageStart < 15000 || nudgedPage) return;
      readCart().then(function (c) { if (c && c.item_count > 0) nudge('leave_cart'); });
    });
  }

  // Signs inside the design tool (the product customiser app): open a long time without adding to cart, many undos,
  // photo uploads tried again and again, an error message, or closed without adding.
  var tool = { open: false };
  function toolEl() { return document.querySelector('.sb-customize-product-popup.sb-customize-product-popup-open'); }
  var ERR_TEXT = /(something went wrong|failed|error|not supported|too (large|big)|could ?n.?t|unable to|try again)/i;
  function toolErrorShown(p) {
    var list = p.querySelectorAll('[role="alert"], [class*="error"], [class*="toast"], [class*="alert"], [class*="notif"], [class*="warning"]');
    for (var i = 0; i < list.length && i < 60; i++) {
      var n = list[i], txt = (n.textContent || '').trim();
      if (txt && txt.length < 200 && ERR_TEXT.test(txt) && shown(n)) return true;
    }
    return false;
  }
  function watchTool() {
    var p = toolEl();
    var engaged = state.msgs.length > 0 || nudgedPage;
    if (p && !tool.open) {
      tool = { open: true, at: Date.now(), added: false, undos: [], files: [], idle: false, errSeen: false, node: p, obs: null };
      if (engaged) track('customiser_open');
      if (window.MutationObserver) {
        var queued = null;
        tool.obs = new MutationObserver(function () {
          if (queued || tool.errSeen) return;
          queued = setTimeout(function () { queued = null; if (tool.open && !tool.errSeen && toolErrorShown(p)) { tool.errSeen = true; nudge('tool_error'); } }, 500);
        });
        tool.obs.observe(p, { childList: true, subtree: true, characterData: true });
      }
    } else if (!p && tool.open) {
      var secs = Math.round((Date.now() - tool.at) / 1000);
      if (tool.obs) tool.obs.disconnect();
      tool.open = false;
      if (engaged) track('customiser_close', { added: tool.added, secs: secs });
      if (!tool.added && secs >= 20) setTimeout(function () { nudge('tool_leave'); }, 700);
    } else if (p && !tool.added && !tool.idle && Date.now() - tool.at > 150000 && Date.now() - lastActive < 30000) {
      tool.idle = true;
      nudge('tool_idle');
    }
  }
  // Inside the design tool, the button sits just above the tool's own bottom bar and its Add To Cart button.
  function toolLift(p) {
    var col = innerWidth - (isMobile() ? 88 : 100), lift = 0;
    var list = p.querySelectorAll('button, a, input, [role="button"], .sb-pd-popup_addtocartbutton');
    for (var i = 0; i < list.length && i < 800; i++) {
      var r = list[i].getBoundingClientRect();
      if (!r.width || !r.height || r.right < col || r.bottom < innerHeight - 110 || r.top > innerHeight) continue;
      lift = Math.max(lift, innerHeight - r.top + 10);
    }
    return Math.min(lift, Math.round(innerHeight * 0.35));
  }

  // ---------- Stay clear of the theme's own bars and drawers ----------
  // The button moves up above the phone menu bar, the sticky Add to cart bar, the back-to-top button and
  // Shopify's theme preview bar, and hides while the theme's cart, search or quick view is open.
  var DODGE = 'mobile-navigation-bar, .product__submit-form-cart, back-to-top, .back-to-top, sticky-add-to-cart, #PBarNextFrameWrapper';
  var OVERLAYS = 'cart-drawer, quickview-drawer, action-search, menu-drawer, .modal';
  function shown(n) {
    var s = getComputedStyle(n);
    if (s.display === 'none' || s.visibility === 'hidden' || Number(s.opacity) < 0.05) return false;
    var r = n.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function fixedOrSticky(n) {
    for (var x = n, i = 0; x && x !== document.body && i < 6; x = x.parentElement, i++) {
      var p = getComputedStyle(x).position;
      if (p === 'fixed' || p === 'sticky') return true;
    }
    return false;
  }
  function overlayOpen() {
    // The design tool is not in the way: Ribbon stays on top of it, ready to help (build item 10).
    if (toolEl()) return false;
    // The theme puts "open-modal" on the page while its cart, search, menu or quick view is open.
    if (document.documentElement.classList.contains('open-modal')) return true;
    var list = document.querySelectorAll(OVERLAYS);
    for (var i = 0; i < list.length; i++) {
      var n = list[i];
      var s = getComputedStyle(n);
      if (s.position !== 'fixed' || s.visibility === 'hidden' || Number(s.opacity) < 0.5 || s.display === 'none') continue;
      var r = n.getBoundingClientRect();
      if (r.width > innerWidth * 0.3 && r.height > innerHeight * 0.5) return true;
    }
    // Apps that open full-screen layers on the page (for example a product designer).
    var kids = document.body.children;
    for (var k = 0; k < kids.length; k++) {
      var c = kids[k];
      if (c === host) continue;
      var cs = getComputedStyle(c);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) < 0.5) continue;
      if ((parseInt(cs.zIndex, 10) || 0) < 100) continue;
      var cr = c.getBoundingClientRect();
      if (cr.width >= innerWidth * 0.9 && cr.height >= innerHeight * 0.9) return true;
    }
    return false;
  }
  var lifted = 0;
  function place() {
    var hide = overlayOpen();
    box.classList.toggle('is-away', hide);
    if (hide && !panel.hidden && !isMobile()) close();
    if (hide) hideNudge();
    var col = innerWidth - (isMobile() ? 88 : 100);
    var tp = toolEl();
    box.classList.toggle('in-tool', !!tp);
    var lift = tp ? toolLift(tp) : 0;
    var list = document.querySelectorAll(DODGE);
    for (var i = 0; i < list.length; i++) {
      var n = list[i];
      if (!shown(n) || !fixedOrSticky(n)) continue;
      var r = n.getBoundingClientRect();
      if (r.right < col || r.top > innerHeight || r.top < innerHeight * 0.45) continue;
      lift = Math.max(lift, innerHeight - r.top + 8);
    }
    if (lift !== lifted) { lifted = lift; box.style.setProperty('--lift', lift + 'px'); }
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; place(); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  setInterval(function () { if (!document.hidden) { place(); watchTool(); } }, 1200);

  // Phone keyboards: keep the input above the keyboard.
  function fitViewport() {
    var vv = window.visualViewport;
    if (!vv || !isMobile()) { box.style.removeProperty('--vvh'); box.style.removeProperty('--vvt'); return; }
    box.style.setProperty('--vvh', vv.height + 'px');
    box.style.setProperty('--vvt', vv.offsetTop + 'px');
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', fitViewport);
    window.visualViewport.addEventListener('scroll', fitViewport);
  }
  var onBreak = function () {
    fitViewport();
    if (!panel.hidden) {
      panel.setAttribute('aria-modal', isMobile() ? 'true' : 'false');
      document.documentElement.classList.toggle('rg-ribbon-lock', isMobile());
    }
  };
  if (MOBILE_Q.addEventListener) MOBILE_Q.addEventListener('change', onBreak); else if (MOBILE_Q.addListener) MOBILE_Q.addListener(onBreak);

  // ---------- Start ----------
  function start() {
    document.body.appendChild(host);
    var css = root.querySelector('link');
    var reveal = function () { host.style.visibility = ''; };
    if (css) { css.addEventListener('load', reveal); css.addEventListener('error', reveal); setTimeout(reveal, 4000); } else reveal();
    place();
    var fromCard = sget('sessionStorage', 'rg_ribbon_from_card') === '1';
    sdel('sessionStorage', 'rg_ribbon_from_card');
    // Every new page starts with the chat closed (Ryan, 15 Oct); a saved chat shows as a red "1" on the button.
    syncCount();
    var onCart = CFG.template === 'cart';
    if (fromCard && state.msgs.length && sget('sessionStorage', 'rg_ribbon_saved_hello') !== '1') {
      sset('sessionStorage', 'rg_ribbon_saved_hello', '1'); // once per visit
      setTimeout(function () { if (panel.hidden) showHello(TXT.helloSaved); }, 1500);
    } else if (!onCart && !state.msgs.length && sget('sessionStorage', 'rg_ribbon_hello') !== '1') {
      setTimeout(function () {
        if (!panel.hidden || box.classList.contains('is-away') || toolEl() || !nudgeEl.hidden) return; // the design tool has its own offers
        sset('sessionStorage', 'rg_ribbon_hello', '1');
        showHello(TXT.hello);
      }, 5000);
    }
  }
  // Another tab of the shop changed the chat: take its copy, so neither tab overwrites the other's messages.
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY || busy) return;
    var s = null;
    try { s = JSON.parse(e.newValue || 'null'); } catch (x) { s = null; }
    if (!s || typeof s !== 'object' || !Array.isArray(s.msgs) || !s.sid) return;
    state = s;
    if (!panel.hidden) renderAll(); else log.innerHTML = '';
    syncCount();
  });

  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
